<template>
  <i
    :class="className"
    
  ></i>
</template>

<script>
export default {
  props: {
    // width: {
    //   type: Number
    // },
    // height: {
    //   type: Number
    // },
    className: {
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
i {
  display: inline-block;
  background-size: cover !important;
}
.icon_warning {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png") no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue